import Vue from "vue";

Vue.component("good-items", {
    props: ["good"],
    methods: {
        descriptionStyle(item) {
            return `margin-left:${(item.level * 25)}px;`;
        }
    },
    computed: {
        descriptionLabel: function () {
            return window.labels.description;
        },
        groupLabel: function () {
            return window.labels.group;
        },
        classLabel: function () {
            return window.labels.class;
        },
        subclassLabel: function () {
            return window.labels.subclass;
		},
		coverageExclusionTooltipLabel: function () {
			return window.labels.coverageExclusionTooltip;
		}
    },
    template: `
		<div>
			<table :class="{ 'has-four-item-columns': good.hasFourItemColumns }">
				<colgroup>
					<col class="good-item-reference-number-column" />
					<col class="good-item-description-column" />
					<col class="good-item-group-column" v-if="good.hasFourItemColumns" />
					<col class="good-item-class-column" v-if="good.hasFourItemColumns" />
					<col class="good-item-subclass-column" v-if="good.hasFourItemColumns" />
					<col class="good-item-details-column" />
				</colgroup>
				<thead>
					<tr>
						<th>&nbsp;</th>
						<th>{{ descriptionLabel }}</th>
						<th v-if="good.hasFourItemColumns">{{ groupLabel }}</th>
						<th v-if="good.hasFourItemColumns">{{ classLabel }}</th>
						<th v-if="good.hasFourItemColumns">{{ subclassLabel }}</th>
						<th>{{ good.classificationSystem }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in good.items" :key="item.id" :id="'goodItem_' + item.id">
						<td>{{ item.referenceNumber }}</td>
						<!--<td style="display: flex; flex-direction: row;">-->
						<td>
							<i v-if="item.excluded" class="fas fa-ban has-text-danger" :title="coverageExclusionTooltipLabel"></i>
							<span :style="descriptionStyle(item)"></span>
							<span v-html="item.description"></span>
						</td>
						<td v-if="good.hasFourItemColumns">{{ item.groupText }}</td>
						<td v-if="good.hasFourItemColumns">{{ item.classText }}</td>
						<td v-if="good.hasFourItemColumns">{{ item.subclassText }}</td>
						<td><span v-html="item.detailsText"></span></td>
					</tr>
				</tbody>
			</table>
		</div>
	`
});